import { initial, last } from 'lodash'

export const parseDateAndTimeFromEta = (eta: string) => {
  const parts = eta.split(' ')
  const dateStr = initial(parts).join(' ')
  const timeStr = last(parts)
  return { dateStr, timeStr }
}

export const parseDateAndTimeFromDeliveryOption = (deliveryOption: string) => {
  const timeStr = deliveryOption.replace('Pickup ', '')
  return { dateStr: null, timeStr }
}
